// extracted by mini-css-extract-plugin
export default {"button":"styles_button__duaC2","deleteButton":"styles_deleteButton__7pdZE"};